<template>
  <BaseDialog
    :title="isEdit ? 'Редактировать' : 'Добавить'"
    :dialog="dialog"
    :is-show-mode="isShowMode"
    :is-edit="isEdit"
    :is-invalid="$v.$invalid"
    :save-btn-loading="saveBtnLoading"
    @close="closeModal"
    @save="save"
  >
    <UITextField
      v-model="location.name"
      label="Название" placeholder="Добавьте название" class="mt-2"
      :disabled="isShowMode"
      :error-messages="errorMessages.name"
      @input="$v.location.name.$touch()"
    />
  </BaseDialog>
</template>

<script>
import { Location } from '@/models'
import { setValidateMessages } from '@/scripts/validation'
import {
  maxLength,
  required,
} from 'vuelidate/lib/validators'
import UITextField from '@/ui/input/UITextField'
import BaseDialog from '@/ui/dialog/BaseDialog'

export default {
  components: {
    UITextField,
    BaseDialog,
  },

  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: {
      type: Object,
      default: null,
    },
  },

  data: () => ({ location: new Location() }),

  validations() {
    return { location: { name: { required, maxLength: maxLength(200) } } }
  },

  computed: {
    isEdit() {
      return !!this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.location.$params).forEach((key) => {
        allErrors[key] = setValidateMessages(this.$v.location[key])
      })

      return allErrors
    },
  },

  methods: {
    save() {
      this.$emit('save', this.location)
    },

    resetModal() {
      this.$v.$reset()
      this.location = new Location()
    },

    closeModal() {
      this.location = new Location()
      this.$emit('closeModal')
    },
  },

  watch: {
    selectedItem(val) {
      this.location = new Location(val)
    },

    dialog(val) {
      !val && this.resetModal()
    },
  },
}
</script>
